import LegalHeader from "@/components/LegalHeader";
import Footer from "@/components/Footer";

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-background">
      <LegalHeader />
      <main className="pt-20 pb-16">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="text-4xl font-bold text-primary mb-4">
                Cookie Policy
              </h1>
              <p className="text-muted-foreground">
                Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}
              </p>
            </div>

            <div className="prose prose-lg max-w-none">
              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">1. Cosa sono i Cookie</h2>
                <p>
                  I cookie sono piccoli file di testo che vengono memorizzati sul Suo dispositivo (computer, tablet, smartphone) quando visita il nostro sito web. I cookie permettono al sito di "ricordare" le Sue azioni e preferenze per un periodo di tempo limitato.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">2. Tipologie di Cookie Utilizzati</h2>
                
                <h3 className="text-xl font-semibold text-primary mb-3">2.1 Cookie Tecnici (Necessari)</h3>
                <p>Questi cookie sono essenziali per il funzionamento del sito web e non possono essere disattivati:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Cookie di sessione:</strong> Mantengono attiva la sessione durante la navigazione</li>
                  <li><strong>Cookie di sicurezza:</strong> Proteggono da attacchi informatici</li>
                  <li><strong>Cookie di funzionalità:</strong> Permettono il corretto funzionamento delle prenotazioni</li>
                </ul>

                <h3 className="text-xl font-semibold text-primary mb-3 mt-6">2.2 Cookie Analitici</h3>
                <p>Questi cookie ci aiutano a comprendere come i visitatori interagiscono con il nostro sito:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Google Analytics:</strong> Analizzano il traffico del sito e le performance</li>
                  <li><strong>Cookie di performance:</strong> Misurano i tempi di caricamento delle pagine</li>
                </ul>

                <h3 className="text-xl font-semibold text-primary mb-3 mt-6">2.3 Cookie di Marketing</h3>
                <p>Questi cookie vengono utilizzati per mostrare pubblicità più rilevanti:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Cookie pubblicitari:</strong> Mostrano annunci personalizzati</li>
                  <li><strong>Cookie di social media:</strong> Permettono la condivisione sui social network</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">3. Durata dei Cookie</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Cookie di sessione:</strong> Si eliminano automaticamente alla chiusura del browser</li>
                  <li><strong>Cookie persistenti:</strong> Rimangono attivi fino alla scadenza o alla cancellazione manuale</li>
                  <li><strong>Cookie analitici:</strong> Conservati per 12 mesi</li>
                  <li><strong>Cookie di marketing:</strong> Conservati per 6 mesi</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">4. Gestione dei Cookie</h2>
                <p>Può gestire i cookie attraverso le impostazioni del Suo browser:</p>
                
                <h3 className="text-xl font-semibold text-primary mb-3">4.1 Browser Web</h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Chrome:</strong> Impostazioni → Privacy e sicurezza → Cookie</li>
                  <li><strong>Firefox:</strong> Opzioni → Privacy e sicurezza → Cookie</li>
                  <li><strong>Safari:</strong> Preferenze → Privacy → Cookie</li>
                  <li><strong>Edge:</strong> Impostazioni → Cookie e autorizzazioni sito</li>
                </ul>

                <h3 className="text-xl font-semibold text-primary mb-3 mt-6">4.2 Disattivazione</h3>
                <p>La disattivazione di alcuni cookie potrebbe limitare la funzionalità del sito. I cookie tecnici non possono essere disattivati senza compromettere il funzionamento del sito.</p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">5. Cookie di Terze Parti</h2>
                <p>Il nostro sito utilizza servizi di terze parti che potrebbero impostare cookie:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Google Analytics:</strong> Per l'analisi del traffico</li>
                  <li><strong>Google Maps:</strong> Per la visualizzazione della mappa</li>
                  <li><strong>Supabase:</strong> Per la gestione delle prenotazioni</li>
                </ul>
                <p className="mt-4">Per maggiori informazioni sui cookie di terze parti, consulti le rispettive privacy policy.</p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">6. Aggiornamenti della Policy</h2>
                <p>Questa Cookie Policy può essere aggiornata periodicamente. Le modifiche saranno pubblicate su questa pagina con la data di ultimo aggiornamento.</p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">7. Contatti</h2>
                <p>Per domande sui cookie o sulla privacy, può contattarci:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Email: info@ristorantearmando.it</li>
                  <li>Telefono: +39 075 388 0397</li>
                  <li>Posta: Via Aganoor Pompili, 25, 06065 Passignano sul Trasimeno (PG)</li>
                </ul>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CookiePolicy; 